import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'


@Injectable({ providedIn: 'root', })

export class SidenavService {

    // With this behavior subject you can save the sidenav state and consumed later into other pages.    
    public animateText$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public mainContentChange$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public sideNavState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    constructor() { }
}